<template>
  <modal @close="smallAlertModalHide">
    <template slot="header">
      <md-button
        class="md-simple md-danger md-just-icon md-round modal-default-button"
        @click="smallAlertModalHide"
      >
        <md-icon>clear</md-icon>
      </md-button>
      <div class="md-layout md-size-100">
        <div class="md-layout-item md-size-50">
          <md-field>
            <md-input
              v-model="filterName"
              placeholder="Tên sản phẩm"
            ></md-input>
          </md-field>
        </div>
        <div class="md-layout-item">
          <md-button @click="modalMode = !modalMode">{{
            modalMode
              ? "Chọn từ danh sách sản phẩm"
              : "Chọn từ cộng tác viên khác"
          }}</md-button>
        </div>
      </div>
    </template>
    <template slot="body">
      <div class="md-layout">
        <div
          class="
            md-size-60 md-xsmall-size-100 md-layout-item
            table-products
            md-scrollbar
          "
        >
          <table id="customers" v-show="!modalMode">
            <tr>
              <th>STT</th>
              <th style="width: 120px">Mã sản phẩm</th>
              <th>Tên sản phẩm</th>
              <th style="width: 120px">Ảnh</th>
              <th>Loại</th>
              <th>Chọn</th>
            </tr>
            <tr :key="index" v-for="(item, index) in search">
              <td>{{ index + 1 }}</td>
              <td>{{ item.data.productId }}</td>
              <td>{{ item.data.name }}</td>
              <td style="text-align: center">
                <div class="image-container">
                  <img :src="item.data.pictureThumbnail" class="box-image" />
                </div>
              </td>
              <td>{{ item.data.tags[0] }}</td>
              <td>
                <md-checkbox
                  :value="item"
                  v-model="productSelected"
                ></md-checkbox>
              </td>
            </tr>
          </table>
          <md-table
            v-model="listUser"
            table-header-color="green"
            v-show="modalMode"
            class="tableClass table-hover"
          >
            <md-table-row
              slot="md-table-row"
              slot-scope="{ item, index }"
              class="clickable"
              @click="selectUser(item)"
            >
              <md-table-cell
                v-bind:class="{
                  activeUser: userSelected.employeeCode === item.employeeCode,
                }"
                class="table-cell"
                md-label="STT"
                >{{ index + 1 }}</md-table-cell
              >
              <md-table-cell
                v-bind:class="{
                  activeUser: userSelected.employeeCode === item.employeeCode,
                }"
                class="table-cell"
                md-label="Mã CTV"
                >{{ item.employeeCode }}</md-table-cell
              >
              <md-table-cell
                v-bind:class="{
                  activeUser: userSelected.employeeCode === item.employeeCode,
                }"
                class="table-cell"
                md-label="Tên"
                >{{ item.name }}</md-table-cell
              >
              <md-table-cell
                v-bind:class="{
                  activeUser: userSelected.employeeCode === item.employeeCode,
                }"
                class="table-cell"
                md-label="Số dư TK"
                >{{
                  item.deposit ? formatNumber(item.deposit) : 0
                }}</md-table-cell
              >
              <md-table-cell
                v-bind:class="{
                  activeUser: userSelected.employeeCode === item.employeeCode,
                }"
                class="table-cell"
                md-label="SL sản phẩm"
                >{{
                  item.listProducts ? item.listProducts.length : 0
                }}</md-table-cell
              >
            </md-table-row>
          </md-table>
        </div>
        <div
          class="
            md-size-40 md-xsmall-size-100 md-layout-item
            table-products
            md-scrollbar
          "
        >
          <div class="md-layout titleProduct md-size-100">Sản phẩm đã chọn</div>
          <transition-group name="list">
            <div
              class="md-size-100 product-box md-layout"
              :key="item.id"
              v-for="(item, index) in productSelected"
            >
              <div class="image-container">
                <img
                  :src="`${
                    item.data.pictureThumbnail
                      ? item.data.pictureThumbnail
                      : '../../../public/img/apple-icon.png'
                  }`"
                  class="box-image"
                />
              </div>
              <p class="md-layout-item">{{ item.data.name }}</p>
              <div @click="removeItem(index)" class="removeIcon">
                <i class="far fa-times-circle clickable"></i>
              </div>
            </div>
          </transition-group>
        </div>
      </div>
    </template>
    <template slot="footer">
      <md-button class="md-simple md-danger" @click="smallAlertModalHide"
        >Hủy</md-button
      >
      <md-button class="md-success md-simple" @click="confirmAdd"
        >Hoàn tất</md-button
      >
    </template>
  </modal>
</template>
<script>
import { Modal } from "@/components";
import firebase from "@/services/firebase-init.js";
import { mapGetters } from "vuex";
export default {
  components: { Modal },
  props: ["listProductsSelected"],
  data() {
    return {
      defaultScr: "../../../public/img/apple-icon.png",
      listUser: [],
      modalMode: false,
      filterName: "",
      suggestion: [],
      db: {},
      listProducts: [],
      productSelected: [],
      productReplace: {},
      userSelected: {},
    };
  },
  async created() {
    // this.listProducts = [];
    this.db = firebase.firestore();
    this.$store.dispatch("FLAG_LOADING", true);
    let bits = localStorage.getItem("bits");
    this.listProducts = JSON.parse(JSON.stringify(this.$listProducts));
    if (this.accessories.length === 0) {
      await this.$store.dispatch("getAllAccessories");
    }
    this.listProducts = this.listProducts.concat(this.accessories);
    this.listProducts.forEach((wine) => {
      if (
        this.listProductsSelected.findIndex((el) => {
          return el.id === wine.data.productId;
        }) !== -1
      ) {
        this.productSelected.push(wine);
      }
    });
    this.db
      .collection(process.env.VUE_APP_USER + bits)
      .where("permission", "==", "Cộng tác viên")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          this.listUser.push(doc.data());
        });
        this.$store.dispatch("FLAG_LOADING", false);
      });
    this.listProducts.forEach((wine) => {
      this.suggestion.push(wine.data.name);
    });
  },
  methods: {
    selectUser(user) {
      this.userSelected = user;
      this.productSelected = [];
      try {
        this.listProducts.forEach((wine) => {
          if (
            user.listProducts.findIndex((el) => {
              return el.id === wine.data.productId;
            }) !== -1
          ) {
            this.productSelected.push(wine);
          }
        });
      } catch (error) {
        this.productSelected = [];
      }
    },
    removeItem(index) {
      this.productSelected.splice(index, 1);
    },
    smallAlertModalHide() {
      this.$emit("smallAlertModalHide", "none");
      this.productSelected = [];
    },
    confirmAdd() {
      this.$emit("smallAlertModalHide", this.productSelected);
      this.productSelected = [];
    },
  },
  computed: {
    ...mapGetters(["$listProducts", "accessories"]),
    search() {
      return this.listProducts.filter(
        (item) =>
          item.data.name
            .toLowerCase()
            .indexOf(this.filterName.toLowerCase()) !== -1
      );
    },
  },
  beforeDestroy() {
    this.listProducts = [];
  },
};
</script>
<style scoped>
.table-products {
  height: 50vh;
  overflow: auto;
}
#customers {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#customers td,
#customers th {
  border: 1px solid #ddd;
  padding: 8px;
  max-width: 20vh;
}

#customers tr:nth-child(even) {
  background-color: #f2f2f2;
}

#customers tr:hover {
  background-color: #ddd;
}

#customers th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: rgb(115, 201, 122);
  color: rgb(0, 0, 0);
  font-style: normal;
  font-weight: normal;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 10;
}
.fixed-input {
  position: fixed;
}
.product-box {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  background: rgb(231, 231, 231);
  border-radius: 5px;
  margin: 5px;
  max-height: 20vh;
  padding: 10px;
}
.titleProduct {
  color: black;
  position: sticky;
  top: 0;
  background-color: rgb(115, 201, 122);
  padding: 12px;
  margin-left: 5px;
  border-radius: 2px;
  z-index: 1;
}
.image-container {
  display: inline-block;
  position: relative;
  width: 60px;
  height: 60px;
  overflow: hidden;
  border-radius: 50%;
  background: white;
}
.box-image {
  width: auto;
  height: 100%;
}

.tableClass {
  border: solid rgb(223, 223, 223) 1px;
  border-radius: 5px;
  background-color: rgb(199, 199, 199) !important;
}
.activeUser {
  background-color: rgb(186, 211, 206);
}
.removeIcon {
  position: relative;
  color: rgb(177, 34, 34);
  height: 20px;
  width: 20px;
}
.list-enter-active,
.list-leave-active {
  transition: all 0.5s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
</style>
